import { useEffect, useState } from "react";
import { use_store } from "../store";
import Button from "./button";
import { useLocation } from "wouter";
import { PaymentLoader } from "./Loading";

export default function ThankYouPage() {
  const { t, refresh_current_user, activation_call, clerk_token, refresh_unique_data } = use_store();
  const [, set_location] = useLocation();
  const [show_loader, set_show_loader] = useState(true);

  useEffect(() => {
    setTimeout(async () => {
      try {
        await refresh_current_user();
        await activation_call();
        await refresh_current_user();
        await refresh_unique_data();
      } catch (e) {
        console.error(e);
      } finally {
        set_show_loader(false);
      }
    }, 500);
  }, [clerk_token]);

  return (
    <>
      <div className="flex flex-col w-full items-center justify-center min-h-[400px]">
        {show_loader && <PaymentLoader />}
      <div className="text-center">
        <p className="bigt mb-[32px]">
          {t("Your subscription is now active.")}
        </p>
        <p className="smallt mb-[48px]">
          {t("You now have full access to all Lulu Loyal features.")}
        </p>
        <Button onClick={() => set_location("/")}>
          {t("Start Analyzing")}
        </Button>
      </div>
    </div>
    </>
  );
}
